module.exports = __webpack_public_path__ + "static/assets/d64d9cafb86a340a37ea3427468b8d5a.png";